import { Controller, FieldValues, RegisterOptions } from "react-hook-form";
import ReactDatePicker from "react-datepicker"; // Import the datepicker
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  label?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  control?: any;
  name?: string;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined;
}

export const ControlledDatePicker = ({
  label,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  control,
  name,
  rules,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <ReactDatePicker
            {...rest}
            selected={value}
            onChange={onChange}
            // minDate={new Date()}
            // minTime={new Date()}
            // @ts-ignore
            // maxTime={new Date().setHours(23, 59, 59)}
            className={`w-full h-[46px] px-4 bg-sky-lighter border ${
              error ? "border-red-base" : "border-gray-border"
            } ${
              error ? "focus:border-red-base" : "focus:border-focused-border"
            } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
            placeholderText={placeholder}
            wrapperClassName="w-full"
          />
        )}
      />
    </div>
  );
};
